var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{style:(_vm.svgStyle)},[_c('text',{style:(_vm.textStyle),attrs:{"x":"50%","y":"50%","text-anchor":"middle","dominant-baseline":"central"}},[_vm._v(" "+_vm._s(_vm.avatarLetter)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }